import React, { useContext, useEffect, useState } from "react";
import Aheader from "../Component/Aheader/Aheader";
import Sidebar from "../Component/Sidebar";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { UserContex } from "../context API/UserContext";
import edit from "./../images/pencil.png";
import delet from "./../images/delete.png";
const Manageservice = ({logout}) => {
  const [services, setServices] = useState([]);
   const [userData, setUserData] = useContext(UserContex);
   const navigate = useNavigate();
  useEffect(() => {
    axios
      .get("https://back.waratechnology.com/api/service/getservice")
      .then((res) => {
        setServices(res.data.data);
        console.log(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  const handledelete =async (id) => {
    await axios
      .delete("https://back.waratechnology.com/api/service/delservice/" + id)
      .then((res) => console.log(res.data))
      .catch((err) => console.log(err));
    window.location.reload();
  };
  useEffect(() => {
    if (!userData.user) {
      navigate("/login");
    }
  });
  return (
    <div>
      {/* <Aheader /> */}
      <div className="flex ">
        <Sidebar logout={logout} />
        <div className="container mx-auto p-4 ml-80">
          <h1 className="text-3xl font-bold mb-4">Services</h1>
          <Link
            to="/addservice"
            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-full"
          >
            Create New Service
          </Link>

          <div className="mt-4 overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="border-collapse border border-slate-500 bg-gray-200 ">
                <tr>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border border-slate-700"
                  >
                    Name
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border border-slate-700"
                  >
                    Description
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border border-slate-700"
                  >
                    Image
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border border-slate-700"
                  >
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {services.map((data, index) => (
                  <tr>
                    <td className="px-6 py-3 text-left text-xs font-medium text-gray-900  tracking-wider border border-slate-700">
                      {data.name}
                    </td>
                    <td className="px-6 py-3 text-left text-xs font-medium text-gray-900  tracking-wider border border-slate-700">
                      {data.description}
                    </td>
                    <td className="px-6 py-3 text-left text-xs font-medium text-gray-900  tracking-wider border border-slate-700">
                      <img
                        className=" h-24"
                        src={"https://back.waratechnology.com" + data.image}
                      />
                    </td>
                    <td className="flex flex-between items-center px-2 py-12 gap-4 text-xs font-medium  text-gray-900 uppercase tracking-wider border border-l-0 border-t-0 border-slate-700">
                      <Link
                        to={`/updateservice/${data.id}`}
                        className=" text-white border-none"
                      >
                        <img className="w-7" src={edit} alt="" />
                      </Link>
                      <img
                        onClick={(e) => handledelete(data.id)}
                        className="w-7 cursor-pointer"
                        src={delet}
                        alt=""
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Manageservice;
